module.exports = __webpack_public_path__ + "static/media/4targets.e709faec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers/4targets.png
// module id = 166
// module chunks = 0